import { COLLECT_PLUS_RELATED_OWNERS } from '../../constants/clickCollectConstants';

export const isCollectPlusRelatedType = (ownerId: number) => COLLECT_PLUS_RELATED_OWNERS
  .some(collectPoint => collectPoint.ownerId === ownerId);

export const getCollectionRelatedStore = (ownerId: number) => {
  const filteredStores = COLLECT_PLUS_RELATED_OWNERS.filter(collectPoint => collectPoint.ownerId === ownerId);
  return filteredStores[0] || {};
};
